module.exports = __webpack_public_path__ + "11.06826d72.png";